/**
 * Extracts the ZIP code from a given address string.
 *
 * @param address The address string to extract the ZIP code from.
 * @returns The extracted ZIP code, or undefined if no valid ZIP code is found.
 */
export function extractZipFromAddress(address?: string): string | undefined {
    if (!address) return undefined;

    const matches = address.match(/\b\d{5}(?:-\d{4})?\b/g);
    if (!matches) return undefined;

    for (let i = matches.length - 1; i >= 0; i--) {
        const zip = matches[i];
        const index = address.indexOf(zip);
        const before = address.slice(0, index);

        // Heuristic 1: ZIP appears after a comma or 2-letter state code
        if (/(,|\b[A-Z]{2})\s*$/.test(before.trim())) {
            return zip;
        }

        // Heuristic 2: ZIP appears far enough into the string (e.g. not a house number)
        if (index > 15) {
            return zip;
        }
    }

    return undefined;
}
